import React from 'react'

import { MOBILE_SCREEN_WIDTH } from '../../constants'
import useMedia from '../../hooks/useMedia'

import { useSigEventsPager } from '../hooks'

import styles from './SigEventDetails.module.css'

const SigEventsDetailsPager = () => {
  const [{ page, totalPages }, { prev, next }] = useSigEventsPager()

  const isDesktop = useMedia(`(min-width: ${MOBILE_SCREEN_WIDTH}px)`)

  if (!totalPages || totalPages < 2) return null
  return (
    <div className={isDesktop ? styles.pager : styles.mobilePager}>
      {page > 1 && (
        <i
          className={'fa fa-chevron-left ' + styles.pagerLeft}
          onClick={prev}
        ></i>
      )}
      {page < totalPages && (
        <i
          className={'fa fa-chevron-right ' + styles.pagerRight}
          onClick={next}
        ></i>
      )}
      <span className={styles.pagerText}>
        {page} of {totalPages}
      </span>
    </div>
  )
}

export default SigEventsDetailsPager
